/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type ContactUsModelState = Readonly<{
    isLoading?: boolean;
}>;

const initialHeaderState: ContactUsModelState = {
    isLoading: false,
};

const reducer = {
    "ContactUs/BeginSendingContactInformation": (draft: Draft<ContactUsModelState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "ContactUs/CompletedSendingContactInformation": (
        draft: Draft<ContactUsModelState>,
        action: { isLoading: boolean },
    ) => {
        draft.isLoading = action.isLoading;
    },
};

const contactUs = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).contactUs = contactUs;

export type ContactUsState = {
    contactUs: ContactUsModelState;
};

type ContactUsReducer = {
    isLoading: typeof contactUs;
};

export type ContactUsActions = Parameters<ContactUsReducer[keyof ContactUsReducer]>[1] | AnyAction;
